const mp = new Set([
  'OTHER',
  'POSITIONAL_AUDIO',
  'IMAGE_PLANE',
  'VIDEO_PLANE',
  'SCREEN_SHARE',
  'STREAM',
  'SVG_PLANE',
  'AI_AVATARS',
  'NPC_AVATARS',
  'INITIAL_POINT',
]);

function isGeneralAsset(type: string) {
  return mp.has(type);
}

export function assetChanged(asset, threeObj, checkGeneral = false) {
  if (!isGeneralAsset(asset.type) && !checkGeneral) {
    return true;
  }

  const getValues = (obj) => {
    if (!obj) return [0, 0, 0];
    if (Array.isArray(obj)) return obj;
    if (typeof obj === 'object' && 'x' in obj && 'y' in obj && 'z' in obj) {
      return [obj.x, obj.y, obj.z];
    }
    return [0, 0, 0];
  };

  const assetPosition = getValues(asset.position);
  const assetRotation = getValues(asset.rotation);
  const assetScale = getValues(asset.scale);

  const initalState = [
    ...assetPosition,
    ...assetRotation,
    ...assetScale,
    asset.textureToChange,
    asset.textureToChangeNormal,
    asset.textureToChangeRoughness,
    asset.textureToChangeMetalness,
  ];

  let newState;

  if (checkGeneral) {
    const objPosition = getValues(threeObj.position);
    const objRotation = getValues(threeObj.rotation);
    const objScale = getValues(threeObj.scale);

    newState = [
      ...objPosition,
      ...objRotation,
      ...objScale,
      threeObj.textureToChange,
      threeObj.textureToChangeNormal,
      threeObj.textureToChangeRoughness,
      threeObj.textureToChangeMetalness,
    ];
  } else {
    newState = [
      ...Object.values(threeObj.position),
      Object.values(threeObj.rotation)[0],
      Object.values(threeObj.rotation)[1],
      Object.values(threeObj.rotation)[2],
      ...Object.values(threeObj.scale),
      threeObj.textureToChange,
      threeObj.textureToChangeNormal,
      threeObj.textureToChangeRoughness,
      threeObj.textureToChangeMetalness,
    ];
  }

  for (let i = 0; i < initalState.length; i++) {
    if (initalState[i] !== newState[i]) {
      return true;
    }
  }

  return false;
}
